import React from "react";
import { Side, Size } from "../../types/system/Layout";
import Utilities from "../../foundation/Utility";

import "./Collapsible.scss";

interface CollapsibleProps {
    name: string;
    open?: boolean;
    className?: string;

    clearanceSide?: Side;
    clearanceSize?: Size;

    children?: React.ReactNode | React.ReactNode[];

    onOpenChange?: (open: boolean) => void;
}

interface CollapsibleState {
    maxHeight?: string;
}

class Collapsible extends React.Component<CollapsibleProps, CollapsibleState> {
    state: CollapsibleState = {};

    render(): React.ReactNode {
        let classNames = this.props.className ? ` ${this.props.className}` : "";

        // Clearance classes
        if (!!this.props.clearanceSide) {
            classNames += ` ${Utilities.getSideClass(
                this.props.clearanceSide,
            )}clearance${Utilities.getSizeClass(this.props.clearanceSize)}`;
        }

        if (this.props.open) classNames += " open";

        return (
            <div className={`collapsible${classNames}`}>
                <span
                    className="title"
                    onClick={() => this.props.onOpenChange?.(!this.props.open)}>
                    {this.props.name}
                </span>
                <span
                    className="content-wrapper"
                    style={{ maxHeight: this.state.maxHeight }}>
                    <span className="content">{this.props.children}</span>
                </span>
            </div>
        );
    }
}

export default Collapsible;
